import http from '@/http'

const URL = '/admin/journey-marks'

export const getConfig = () => http.get(`${URL}/config`)
export const updateConfig = (payload) => http.put(`${URL}/config`, payload)
export const list = () => http.get(URL)
export const create = (payload) => http.post(URL, payload)
export const update = (id, payload) => http.put(`${URL}/${id}`, payload)
export const remove = (id) => http.delete(`${URL}/${id}`)
export const importFile = (formData) => http.post(`${URL}/import-file`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
export const downloadTemplate = () => http.get(`${URL}/import-template`, { responseType: 'blob' })

export default { getConfig, updateConfig, list, create, update, remove, importFile, downloadTemplate }
